export const FLASH_MESSAGE_ADD = "FLASH_MESSAGE/ADD";
